import { makeStyles } from '@material-ui/core'
import { Elements, ResetPassword } from '@tfo/common'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { LoginMethod } from '../../../models/enums/LoginMethod'
import $http from '../../../utils/$http'


type Props = {
    loginMethod: LoginMethod
}

const { Heading4 } = Elements

const ChangePassword: React.FC<Props> = ({loginMethod}) => {
	const intl = useIntl()

	const useStyles = makeStyles({
		input: {
			fontFamily: 'Arial',
			fontSize: '1.6rem',
			letterSpacing: '0.001rem',
			lineHeight: '2.8rem',
			color: '#3D3D3C',
			background: '#ffffff',
			border: '1px solid #dfdfde',
			position: 'relative',
			padding: '1.7rem 2.4rem',
			width: '100%',
			margin: 0,
			opacity: 1,
			zIndex: 0,
			'& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
				borderBottom: 'none',
			},
			'.MuiTextField-root:focus': {
				borderColor: '#0098c3',
				zIndex: 2,
			},
		},
		inputPassword: {
			width: '100%',
			padding: '0.6rem 0.6rem',
			borderRadius: '0',
			backgroundColor: '#FFFFFF'

		},
	
		button: {
			width: '100%',
			height: '64px',
			backgroundColor: '#009B48',
			fontWeight: 'bold',
			color: '#ffffff',
			fontStyle: 'normal',
			fontFamily: 'Arial, sans-serif',
			textTransform: 'none',
			fontSize: '1.6rem',
			borderRadius: 0,
			'&:hover': {
				backgroundColor: '#48C865',
			},
		},
		label: {
			marginBottom: '10px',
		},
		passwordValidations: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			margin: 'auto',
			marginLeft: '30px',
			width: '50%',
			height: '24px',

		},
		passwordValidationsGrid: {
			margin: 'auto',
			width: '350px',
			borderRadius: '12px',
			marginBottom: '12px'
		},
		passwordRepeatErrorText: {
			textAlign: 'left',
			color: '#F50057',
			fontWeight: 'bold',
			letterSpacing: '0.4px'
		},
		changePasswordBox:{ 
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: '#fff',
			borderRadius:'1rem',
			boxShadow:'0 0 0.7rem 0.1rem hsla(164,7%,70%,.1) ',
			margin: 'auto' ,
			padding:'3rem 5rem',
			minWidth: '100%',
			minHeight: '15rem'	
		},
		heading: {
			color: '#666666',
			marginBottom: '3rem',

		}
		
	})

	const classes = useStyles()

	const changePassword = async (data: any) => {
		if(loginMethod !== LoginMethod.Password){
			return await $http.post<any>(`/user/password/set-new`, data)
		}
		return await $http.post<any>(`/user/password/change`, data)
	}

	return (
		<>
			<div className={classes.changePasswordBox}>
				{loginMethod === LoginMethod.Password && <Heading4 className={classes.heading}>{intl.formatMessage({ id: 'common.changePassword' })}</Heading4>}
				{loginMethod !== LoginMethod.Password && <Heading4 className={classes.heading}>{intl.formatMessage({ id: 'common.createPassword' })}</Heading4>}
			
				<ResetPassword
					showOldPassword={loginMethod === LoginMethod.Password}
					apiMethod={changePassword}
					useStyles={useStyles}
					hasLabels={true}
				/>
			</div>
		</>
	)
}

export default ChangePassword